import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import {OrderStatusPageContext} from "@MasterBluePrint/Overrides/Pages/OrderStatusPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderDetailsPaymentTermsStyles {
    titleText?: TypographyPresentationProps;
    termsText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const paymentTermsStyles: OrderDetailsPaymentTermsStyles = {
    wrapper: {
        css:css`
            padding-bottom: 0.625rem;
            font-family: 'Lato',sans-serif;
            letter-spacing: 0;
            line-height: 1.5rem;
        `,
    },
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 0.75rem;
            }
            margin-bottom: 0.3125rem;
            margin-right: 0.3125rem;
            color: #002554;		
            font-size: 0.875rem;
            font-family: 'Roboto', sans-serif;
            font-weight: bold;
            display: inline-block;
            &:after {
                content: ':';
                display: inline-block;
            }
        `,
    },
    termsText: {
        css: css`
            color: #333F48;
            font-size: 0.875rem;
        `,        
    },
};
const styles = paymentTermsStyles;

const OrderDetailsPaymentTerms: FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);

    if ((!order || !order.terms)&&(!orderData ||!orderData.terms)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Payment Method")}
            </Typography>
            <Typography {...styles.termsText}>{order?.terms||orderData?.terms}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDetailsPaymentTerms),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage",OrderStatusPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
